import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

if (isMobile) {
    import('./components/m-entry').then(M => {
        ReactDOM.render(<M.default />, document.getElementById('root'));
    });
} else {
    import('./components/pc-entry').then(PC => {
        ReactDOM.render(<PC.default />, document.getElementById('root'));
    });
}
